module.exports = __webpack_public_path__ + "images/btn-socialsign-fb.png?e38a0";